var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 19,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.14 10.472l.507-3.305H6.476V5.022c0-.904.443-1.785 1.863-1.785H9.78V.423S8.472.2 7.22.2C4.61.2 2.903 1.783 2.903 4.648v2.519H0v3.305h2.903v7.99a11.51 11.51 0 003.573 0v-7.99H9.14z",
    fill: "#31347A"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iMTkiIHZpZXdCb3g9IjAgMCAxMCAxOSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTkuMTM5NyAxMC40NzE5TDkuNjQ2NiA3LjE2NzAzSDYuNDc1NzFWNS4wMjIzOEM2LjQ3NTcxIDQuMTE4MjMgNi45MTg2MyAzLjIzNjkzIDguMzM4OSAzLjIzNjkzSDkuNzgwNThWMC40MjMzMzdDOS43ODA1OCAwLjQyMzMzNyA4LjQ3MjE5IDAuMjAwMDM2IDcuMjIxMzIgMC4yMDAwMzZDNC42MDk3NiAwLjIwMDAzNiAyLjkwMjg5IDEuNzgyNzkgMi45MDI4OSA0LjY0ODE5VjcuMTY3MDNILTMuMDUxNzZlLTA1VjEwLjQ3MTlIMi45MDI4OVYxOC40NjExQzMuNDg0OTcgMTguNTUyNSA0LjA4MTU2IDE4LjYgNC42ODkzIDE4LjZDNS4yOTcwNCAxOC42IDUuODkzNjMgMTguNTUyNSA2LjQ3NTcxIDE4LjQ2MTFWMTAuNDcxOUg5LjEzOTdaIiBmaWxsPSIjMzEzNDdBIi8+Cjwvc3ZnPgo=";
export { SvgFacebook as ReactComponent };